import React from 'react';
import Stack from '@mui/material/Stack';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import MuiLink from 'components/commom/MuiLink';
import { useNavigate } from 'react-router-dom';
import BreadcrumbIcon from 'assets/images/Dashboard/pending-detail.svg';

function MuiBreadcrumbs({ list }) {
  const navigate = useNavigate();

  const handleClick = (link) => {
    navigate(link);
  };

  return (
    <Stack>
      <Breadcrumbs
        separator={<img src={BreadcrumbIcon} alt={'icon'} />}
        aria-label="breadcrumb"
      >
        {list.length > 0 &&
          list.map((value) => (
            <>
              {value.isDisbale ? (
                <MuiLink cursor="default" disabled={value?.isDisbale}>
                  {value.title}
                </MuiLink>
              ) : (
                <MuiLink onClick={() => handleClick(value.Link)}>
                  {value.title}
                </MuiLink>
              )}
            </>
          ))}
      </Breadcrumbs>
    </Stack>
  );
}

export default MuiBreadcrumbs;
